import type { ComponentType } from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface GroupChild {
  to: string;
  icon: ComponentType<{ className?: string }>;
  label: string;
}

interface Props {
  label: string;
  icon: ComponentType<{ className?: string }>;
  items: GroupChild[];
  isPathActive: (to: string) => boolean;
  triggerClassName: string;
}

/** Icon-only nav group of the collapsed sidebar: its items open in a dropdown to the right. */
export function SideNavGroupDropdown({ label, icon: Icon, items, isPathActive, triggerClassName }: Props) {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <button type="button" aria-label={label} title={label} className={cn(triggerClassName, 'w-full cursor-pointer')}>
          <Icon className="size-4 shrink-0" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent side="right" align="start" sideOffset={8} className="min-w-52">
        <DropdownMenuLabel className="text-xs text-muted-foreground">{label}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {items.map((child) => (
          <DropdownMenuItem key={child.to} asChild className="cursor-pointer">
            <NavLink
              to={child.to}
              className={cn(isPathActive(child.to) && 'bg-accent text-accent-foreground font-medium')}
            >
              <child.icon className="size-4 shrink-0" />
              <span className="truncate">{child.label}</span>
            </NavLink>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
